import { render, staticRenderFns } from "./UFaq.vue?vue&type=template&id=7a348fb6&"
import script from "./UFaq.vue?vue&type=script&lang=js&"
export * from "./UFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports